import React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import Component1 from "./Components/component1/Component1";
import Component2 from "./Components/component2/Component2";
import Component3 from "./Components/component3/Component3";
import Component4 from "./Components/component4/Component4";
import Component5 from "./Components/component5/Component5";
import Component6 from "./Components/component6/Component6";
import Component7 from "./Components/component7/Component7";
import PromotionsSlider from "./Components/promotions-slider/PromotionsSlider";
import MenuComponent from "./Components/MenuComponent/MenuComponent";
import MenuPage from "./Components/MenuComponent/MenuPage";
import InfoForOlds from "./Components/info-for-olds/InfoForOlds";
import TelegramChannel from "./Components/telegram-channel/TelegramChannel";
import DeliveryMainPage from "./Components/DeliveryPage/DeliveryMainPage/DeliveryMainPage";
import "./styles/global.scss";

function LandingLayout() {
  return (
    <div className="main site-root">
      <Component1 />
      <PromotionsSlider />
      <Component7 />
      <MenuComponent />
      <InfoForOlds />
      <TelegramChannel />
      <Component6 />
      <Component2 />
      <Component3 />
      <Component4 />
      <Component5 />
    </div>
  );
}

function DeliveryLayout() {
  return (
    <div className="main site-root">
      <DeliveryMainPage />
    </div>
  );
}

const router = createHashRouter([
  {
    path: "/",
    element: <LandingLayout />,
  },
  {
    path: "/delivery",
    element: <DeliveryLayout />,
  },
  {
    path: "/menu",
    element: <MenuPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
